import { Button } from "@/components/Product/ECommerce/components/orderButton/components/button";
import { Base } from "@/components/Product/ECommerce/components/orderButton/orderButton.base";

export const OrderButton = Object.assign(Base, {
    Button: Button
});
